import React, { useEffect, useState } from 'react';
import './MembershipCard.css';
import Navbar from '../Navbar/Navbar';
import { members } from '../../../Redux/Slice/AuthSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetAllMembershipQuery } from '../../../Redux/Api/AuthApi';

const MembershipCard = () => {
  const [activePlan, setActivePlan] = useState(null);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [allData,setAllData] = useState()


    const {data,isSuccess} = useGetAllMembershipQuery()
  
    useEffect(()=>{
     if(isSuccess){
      setAllData(data)
     }
    },[data,isSuccess,setAllData])
 
    console.log(allData)

  const handleSub = ({name,price,id,e})=>{
    e.preventDefault()
    dispatch(members(JSON.stringify({name,price,id})))
    navigate('/portal/booking/party/checkout')
  }


  return (
    <div className='portal-kiga-question-1-main'>
      <Navbar/>
      <section className='portal-kiga-question-1-section'>
       <div className='portal-kiga-question-1-section-header'>
        <p>choose best subscription suit for you?</p>
      </div>
          <div className="kiga-membership-card-container">
          { allData?.map((plan,index) => (
            <div
              className={`kiga-membership-card-subscription-card ${
                plan?.name === "Annual Premium" ? "popular" : ""
              }`}
              key={index}
            >
              <div className="kiga-membership-card-name">{plan?.name}</div>

              <div className="kiga-membership-card-price">
                Rwf {plan?.amount?.toLocaleString()}
                <span>/{plan?.membershipPlan}</span>
              </div>
              <div className="kiga-membership-card-features">
                <ul>
                  {plan?.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>

              <button
                className="kiga-membership-card-subscribe-btn kiga-membership-card-btn-premium"
                onClick={(e)=>handleSub({name:plan?.name,price:plan?.amount,id:plan?._id,e})}
              >
                Subscribe to {plan?.name}
              </button>
            </div>
          ))}
        </div>
    </section>
    </div>
  );
};

export default MembershipCard;